/**
 * Repayment type enum.
 */
export enum RepaymentTypeEnum {
  CAPITAL_AND_INTEREST = 'Capital and interest',
  INTEREST_ONLY = 'Interest only',
  PART_AND_PART = 'Part and Part'
}
